import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE, DBK_FONT_FAMILY } from "../../../../src/constants";

export default MediaQueryStyleSheet.create({
  marketValueLabel: {
    // fontSize: 16,
  },
  decimalStyle: {
    color: PALETTE.secondaryActive,
    fontFamily: DBK_FONT_FAMILY.dbkTextDisplay,
    fontSize: 32,
  },
  marketValueText: {
    color: PALETTE.secondaryActive,
    fontFamily: DBK_FONT_FAMILY.dbkTextDisplay,
    fontSize: 40,
  },
  currencyStyle: {
    fontSize: 24,
  }
});
